(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tt6-parent-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt6-parent-tabs'))
    customElements.define(
      'tt6-parent-tabs',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          const signal = this.abort.signal;
          this.initialize = () => {
            this.tabs = [...this.querySelectorAll('[role="tab"]')];
            this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
            this.tabs.forEach((tab, index) => {
              tab.addEventListener('click', () => this.select(index), { signal });
              tab.addEventListener(
                'keydown',
                (event) => {
                  if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
                  event.preventDefault();
                  const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
                  this.select(next);
                  this.tabs[next].focus();
                },
                { signal }
              );
            });
            this.addEventListener(
              'shopify:block:select',
              (event) => {
                const block = event.target.closest('[data-parent-group]');
                if (block) this.select(Number(block.dataset.parentGroup) - 1);
              },
              { signal }
            );
          };
          if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', this.initialize, { once: true, signal });
          else this.initialize();
        }
        select(index) {
          this.tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            this.panels[i].hidden = i !== index;
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
        }
      }
    );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt6-pdp-controls"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt6-pdp-controls')) {
    customElements.define(
      'tt6-pdp-controls',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          this.init = this.init.bind(this);
          if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', this.init, { once: true, signal: this.abort.signal });
          else queueMicrotask(this.init);
          document.addEventListener('product-info:loaded', this.init, { signal: this.abort.signal });
        }
        init() {
          if (this.ready) return;
          this.main = document.getElementById(`shopify-section-${this.dataset.mainId}`);
          this.form = document.getElementById(this.dataset.formId);
          this.bar = this.querySelector('.tt6-sticky');
          this.button = this.querySelector('.tt6-sticky__submit');
          const data = this.querySelector('[data-tt6-variants]');
          if (!this.form || !this.main || !this.bar || !this.button || !data) return;
          this.variants = JSON.parse(data.textContent);
          this.topButton = this.form.querySelector('[type="submit"]');
          if (!this.topButton) return;
          this.ready = true;
          this.dataset.ready = 'true';
          this.label = this.querySelector('[data-tt6-label]');
          this.addLabel = this.label.textContent;
          const signal = this.abort.signal;
          this.addEventListener(
            'change',
            (event) => {
              const input = event.target.closest('input[data-tt6-option]');
              if (!input) return;
              const source = Array.from(this.main.querySelectorAll('variant-picker input[data-option-value]')).find(
                (el) => el.dataset.optionIndex === '1' && el.value === input.dataset.tt6Option
              );
              if (!source) {
                this.goToPurchase();
                return;
              }
              if (source.checked) return;
              this.pendingInput = input;
              this.button.disabled = true;
              source.click();
            },
            { signal }
          );
          this.form.addEventListener(
            'variant:change',
            () => {
              this.sync();
              const selected = this.pendingInput;
              this.pendingInput = null;
              if (selected)
                setTimeout(() => {
                  if (!this.isConnected) return;
                  if (this.main.contains(document.activeElement) || document.activeElement === document.body)
                    selected.focus({ preventScroll: true });
                }, 150);
            },
            { signal }
          );
          this.form.addEventListener('submit', () => this.sync(), { signal });
          this.observer = new MutationObserver(() => this.sync());
          this.observer.observe(this.form, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'value'],
            childList: true,
            characterData: true,
            subtree: true,
          });
          // Publishes the bar's real height so the page reserve matches it at
          // every breakpoint instead of assuming the desktop 110px.
          this.setBarHidden = (hidden) => {
            this.bar.hidden = hidden;
            if (hidden) return;
            const height = Math.round(this.bar.getBoundingClientRect().height);
            if (height && height !== this.barHeight) {
              this.barHeight = height;
              document.documentElement.style.setProperty('--tt6-sticky-height', height + 'px');
            }
          };
          this.visibility = new IntersectionObserver((entries) => {
            const entry = entries[0];
            this.setBarHidden(entry.isIntersecting || entry.boundingClientRect.bottom >= 0);
          });
          this.visibility.observe(this.topButton);
          this.updateVisibility = () => {
            if (this.visibilityFrame) return;
            this.visibilityFrame = requestAnimationFrame(() => {
              this.visibilityFrame = null;
              this.setBarHidden(this.topButton.getBoundingClientRect().bottom >= 0);
            });
          };
          window.addEventListener('scroll', this.updateVisibility, { passive: true, signal });
          window.addEventListener('resize', this.updateVisibility, { passive: true, signal });
          this.updateVisibility();
          document.addEventListener(
            'click',
            (event) => {
              const trigger = event.target.closest('[data-tt6-purchase]');
              if (!trigger) return;
              event.preventDefault();
              this.goToPurchase();
            },
            { signal }
          );
          this.sync();
        }
        sync() {
          if (!this.topButton) return;
          const id = this.form.querySelector('[name="id"]')?.value;
          const variant = this.variants.find((item) => String(item.id) === String(id));
          const busy = this.topButton.hasAttribute('aria-busy');
          this.button.disabled =
            this.topButton.disabled || this.topButton.getAttribute('aria-disabled') === 'true' || busy;
          this.button.toggleAttribute('aria-busy', busy);
          const mainLabel = this.topButton.querySelector('.btn-text>span');
          this.label.textContent = mainLabel?.textContent || this.addLabel;
          if (variant) {
            this.querySelector('[data-tt6-price]').innerHTML = variant.price;
            const compare = this.querySelector('[data-tt6-compare]');
            compare.innerHTML = variant.compare || '';
            compare.hidden = !variant.onSale;
            this.querySelector('[data-tt6-color]').textContent = variant.title;
            this.querySelectorAll('input[data-tt6-option]').forEach((input) => {
              input.checked = input.value === String(variant.id);
            });
          }
          const topError = this.form.querySelector('.product-form__error-message');
          const error = this.querySelector('.tt6-sticky__error');
          error.hidden = !topError || topError.hidden || !topError.textContent.trim();
          error.textContent = error.hidden ? '' : topError.textContent;
        }
        goToPurchase() {
          const target = this.main.querySelector('variant-picker') || this.main;
          target.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start',
          });
          const input = target.querySelector('input:checked, select');
          input?.focus({ preventScroll: true });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.visibility?.disconnect();
          cancelAnimationFrame(this.visibilityFrame);
          this.visibilityFrame = null;
          this.ready = false;
          delete this.dataset.ready;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt6-support-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('support-tabs')) {
    customElements.define('support-tabs', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.initialize = () => {
          const root = this.closest('.page-width') || this.parentElement;
          this.tabs = [...root.querySelectorAll('[role="tab"]')];
          this.panels = [...this.querySelectorAll(':scope > [role="tabpanel"]')];
          if (!this.tabs.length) return;
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(index), { signal });
            tab.addEventListener('keydown', event => {
              if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
              event.preventDefault();
              const last = this.tabs.length - 1;
              let next = index;
              if (event.key === 'Home') next = 0;
              else if (event.key === 'End') next = last;
              else if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
              else next = index === 0 ? last : index - 1;
              this.select(next);
              this.tabs[next].focus();
            }, { signal });
          });
          document.addEventListener('shopify:block:select', event => {
            const panel = event.target.closest('[role="tabpanel"]');
            if (!panel) return;
            const target = this.panels.indexOf(panel);
            if (target >= 0) this.select(target);
          }, { signal });

        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.initialize, { once: true, signal });
        else this.initialize();
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
        });
        this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      }
      disconnectedCallback() { this.abort && this.abort.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt6-upgrades"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt6-upgrade-carousel')) {
    customElements.define(
      'tt6-upgrade-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.abort = new AbortController();
          this.init = this.init.bind(this);
          if (document.readyState === 'loading')
            document.addEventListener('DOMContentLoaded', this.init, { once: true, signal: this.abort.signal });
          else queueMicrotask(this.init);
        }
        init() {
          this.track = this.querySelector('.tt6-upgrades__track');
          this.cards = [...this.querySelectorAll('[data-upgrade-card]')];
          if (!this.track || !this.cards.length) return;
          const signal = this.abort.signal;
          this.dots = [...this.querySelectorAll('[data-upgrade-dot]')];
          const update = () => {
            const edge = this.track.getBoundingClientRect().left;
            this.index = this.cards.reduce(
              (best, card, index) =>
                Math.abs(card.getBoundingClientRect().left - edge) <
                Math.abs(this.cards[best].getBoundingClientRect().left - edge)
                  ? index
                  : best,
              0
            );
            const maximum = this.track.scrollWidth - this.track.clientWidth;
            this.querySelector('.tt6-upgrades__nav').hidden = maximum < 2;
            if (maximum > 2 && this.track.scrollLeft >= maximum - 2) this.index = this.cards.length - 1;
            this.dots.forEach((dot, index) => {
              if (index === this.index) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
          };
          this.track.addEventListener('scroll', update, { passive: true, signal });
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), { signal }));
          this.track.addEventListener(
            'keydown',
            (event) => {
              if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key))
                return;
              event.preventDefault();
              this.go(
                event.key === 'Home'
                  ? 0
                  : event.key === 'End'
                  ? this.cards.length - 1
                  : this.index + (event.key === 'ArrowRight' ? 1 : -1)
              );
            },
            { signal }
          );
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
              if (index >= 0) this.go(index);
            },
            { signal }
          );
          this.resize = new ResizeObserver(update);
          this.resize.observe(this.track);
          update();
        }
        go(index) {
          const card = this.cards[Math.max(0, Math.min(this.cards.length - 1, index))];
          const left =
            this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
          this.track.scrollTo({
            left,
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.resize?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
